import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface ShipperPremiumServiceSubscriptionResource
    extends ng.resource.IResourceClass<ng.resource.IResource<any>> {
    getPackages: ng.resource.IResourceMethod<
        ng.resource.IResource<ShipperPremiumServiceSubscriptionPackageDto[]>
    >;
}

function shipperPremiumServiceSubscriptionResource(
    $resource: ng.resource.IResourceService
): ShipperPremiumServiceSubscriptionResource {
    return <ShipperPremiumServiceSubscriptionResource>$resource(
        config.monolithApi + '/shipper-premium-service-subscriptions/:id',
        { id: '@id' },
        {
            getPackages: {
                url:
                    config.monolithApi +
                    '/shipper-premium-service-subscriptions/packages',
                method: 'GET',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory(
        'shipperPremiumServiceSubscriptionResource',
        shipperPremiumServiceSubscriptionResource
    );
